import {sortBy} from 'lodash'

const places = [
  {id: 1, name: 'AMCFZ'},
  {id: 2, name: 'Ajman Free Zone'},
  {id: 3, name: 'DAFZA'},
  {id: 4, name: 'DMCC'},
  {id: 5, name: 'DED'},
  {id: 6, name: 'DTEC'},
  {id: 7, name: 'DWTC'},
  {id: 8, name: 'Dubai South'},
  {id: 9, name: 'FCC'},
  {id: 10, name: 'IFZA'},
  {id: 11, name: 'JAFZA'},
  {id: 12, name: 'KIZAD'},
  {id: 13, name: 'Masdar'},
  {id: 14, name: 'RAK Civil Aviation'},
  {id: 15, name: 'RAKEZ'},
  {id: 16, name: 'SHAMS'},
  {id: 17, name: 'UAQ FTZ'},
  {id: 18, name: 'DIC'},
  {id: 19, name: 'MEYDAN'},
  {id: 20, name: 'DIFC'},
  {id: 21, name: 'Self-sponsored'},
  {id: 22, name: 'Property Visa'},
  {id: 23, name: 'Dependent visa'}
]

const placesOfRegistration = sortBy(places, ['name'])

export default placesOfRegistration



// WEBPACK FOOTER //
// ./src/constants/placesOfRegistartion.js